import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Detail_3({ item, isSub }) {
  //const isHtml = item.scale.isHtml;
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  return (
    <Row className={"mb-3 mx-0"} style={{ marginBottom: "6px" }}>
      {!isSub && (
        <Row className={"justify-content-center  mx-0"} style={{ fontSize: 22, fontWeight: 700 }}>
          {item.scopeName}
        </Row>
      )}

      <div className={"py-3 rounded-4"} style={{ backgroundColor: isSub ? "white" : "#0048aa" }}>
        <Row>
          <Col className={"align-content-center"}>
            {isSub && <Row className={"detail-scope-name-blurred-wrap-up mb-2 px-3"}>{item.scopeName}</Row>}
            <Row style={{ color: !isSub ? "white" : "" }} className={"main-scope-name-detail-wrap-up-new px-3 pb-2"}>
              {item.name}
            </Row>
          </Col>
        </Row>
        <Row className={"mx-0"}>
          <Col className={"align-content-center"} xs={5}>
            <Row className={"_scale-detail-text-new-wrap-up"}>
              <div
                style={{ color: !isSub ? "white" : "" }}
                dangerouslySetInnerHTML={{ __html: item.generalInformationText }}
              ></div>
            </Row>
          </Col>

          <Col xs={7} className={"align-content-center "}>
            <Row
              className={"justify-content-between mt-5 round-40px border border-2  mx-0"}
              style={{ borderColor: "#A6D1FF", padding: "0 10px" }}
            >
              {item.scale.ranges.map((range, i) => {
                const isLast = item.scale.ranges.length - 1 === i;
                const isFirst = i === 0;

                let margins = {
                  cubeMargin: "0%",
                  textMargin: "50%",
                };
                if (isFirst) {
                  margins.cubeMargin = "-25%";
                  margins.textMargin = "75%";
                }
                if (isLast) {
                  margins.cubeMargin = "25%";
                  margins.textMargin = "25%";
                }
                if (range.isHit === true) {
                  return (
                    <Col xs={"auto"} className={"align-content-center position-relative p-0"}>
                      <div className={"p-0"} style={{ width: "45px" }}>
                        <Row
                          className={"position-absolute translate-middle-x mx-0"}
                          style={{ top: "-25px", left: "50%" }}
                        >
                          <Col
                            xs={"auto"}
                            className={"position-relative px-0"}
                            style={{ marginLeft: margins.textMargin }}
                          >
                            <div
                              className={" z-0  rotated-div-cube  "}
                              style={{
                                marginTop: 6,
                                height: 15,
                                width: 15,
                                marginLeft: margins.cubeMargin,
                                backgroundColor: isSub ? "#007aff" : "#fff5ce",
                              }}
                            ></div>
                            <div
                              className={
                                " px-2 z-1  detail-hit-range-name-above-wrap-up translate-middle-x text-nowrap"
                              }
                              style={{
                                marginTop: -30,
                                backgroundColor: isSub ? "#007aff" : "#fff5ce",
                                color: isSub ? "white" : "#00428a",
                              }}
                            >
                              {range.text}
                            </div>
                          </Col>
                        </Row>
                        <div
                          className={"hit-scale-style-variable-opacity-wrap-up-round p-0 _flex-center"}
                          style={{ margin: "2px -7.5px" }}
                        >
                          {elementScore}
                        </div>
                      </div>
                    </Col>
                  );
                } else {
                  return (
                    <Col xs={"auto"} className={"align-content-center p-0"}>
                      <div
                        style={{
                          backgroundColor: "white",
                          width: "fit-content",
                          height: "fit-content",
                          borderRadius: "50%",
                          padding: 0,
                        }}
                      >
                        <div
                          className={"scale-style-variable-opacity-wrap-up-round"}
                          style={{
                            opacity: (i + 1) * (1 / item.scale.ranges.length),
                            backgroundColor: isSub ? "#00428a" : "#02a4ff",
                          }}
                        ></div>
                      </div>
                    </Col>
                  );
                }
              })}
            </Row>
          </Col>
        </Row>
      </div>
    </Row>
  );
}
